import { useEffect, useRef, useState } from 'react'

import { EMPTY_STRING } from '../../constants/common'
import { EVENT_NAME_RESIZE } from '../../constants/event'

import { MAX_LINES } from './useReadMore.constants'

export function useReadMore({ maxLines = MAX_LINES, textData = EMPTY_STRING }) {
  const [isReadMore, setIsReadMore] = useState(false)
  const [showReadMore, setShowReadMore] = useState(false)

  const textRef = useRef(null)

  function checkOverflow() {
    if (textRef.current) {
      const computedStyle = getComputedStyle(textRef.current)
      const lineHeight = parseFloat(computedStyle.lineHeight)
      const maxHeight = lineHeight * maxLines
      const isOverflowing = textRef.current.scrollHeight > maxHeight

      setShowReadMore(isOverflowing)

      if (isOverflowing && !isReadMore) {
        textRef.current.style.display = '-webkit-box'
        textRef.current.style.WebkitBoxOrient = 'vertical'
        textRef.current.style.WebkitLineClamp = maxLines
        textRef.current.style.overflow = 'hidden'
        textRef.current.style.textOverflow = 'ellipsis'
      } else {
        textRef.current.style.display = 'block'
        textRef.current.style.WebkitLineClamp = 'unset'
        textRef.current.style.overflow = 'visible'
      }
    }
  }

  useEffect(() => {
    checkOverflow()
    window.addEventListener(EVENT_NAME_RESIZE, checkOverflow)

    return () => window.removeEventListener(EVENT_NAME_RESIZE, checkOverflow)
  }, [isReadMore, maxLines, textData])

  function handleClickReadMore() {
    setIsReadMore(prev => !prev)
  }

  return { handleClickReadMore, isReadMore, showReadMore, textRef }
}
